<template>
<div class="mt-2 animate__animated animate__fadeIn">
    <v-form ref="form" v-model="valid" lazy-validation v-if="!re">

        <div class="mt-4 pt-2 text-center">
            <v-text-field type="password" v-model="data.password" label="ตั้งรหัสผ่านใหม่ที่ต้องการ" required outlined :rules="passwordRules" class="text-center"></v-text-field>
        </div>

        <div class="text-center mt-5">
            <v-btn :disabled="!valid" color="light-blue darken-4" class="mr-4" @click="validate" style="color:#ffffff;">
                บันทึก
            </v-btn>
        </div>

    </v-form>

    <div v-if="re" v-html="msg"></div>

</div>
</template>

<script>
export default {

    components: {

    },
    props: {

        member: null

    },

    data: () => ({
        valid: true,
        msg: null,
        re: null,
        data: {

        },

        passwordRules: [
            v => !!v || 'โปรดระบุรหัสผ่านที่ต้องการด้วยค่ะ',
            v => (v && v.length >= 6) || 'รหัสผ่านอย่างน้อย 6 ตัวค่ะ',
            v => /^[a-zA-Z0-9]*$/.test(v) || 'a-z หรือ ตัวเลขเท่านั้นค่ะ',

        ],

    }),

    computed: {

    },

    watch: {

    },
    methods: {

        validate() {
            this.$refs.form.validate()
            let $vm = this
            setTimeout(function () {
                if ($vm.valid == true) {
                    $vm.changePassword()
                }
            }, 100);
        },

        changePassword() {

                 

            let url = "member/changePassword";
            let $vm = this;
            const formData = this.$formData(
                this.data
            );

            this.$API
                .post(url, this.formData(formData))
                .then(function (res) {
                    $vm.checkApi(res);
                    if (res.data.re == 'success') {
                        $vm.msg = res.data.msg
                        $vm.re = res.data.re
                    }

                })
                .catch(function (error) {
                    console.log(error);
                });

        },

    },

    created() {

        this.data = this.member
        this.data.password = null

    },
};
</script>
